import { CalendarEntry } from '@/utils/calendar-dates';
import { playSound } from '@/utils/playSound';
import {
  VuexModule,
  Module,
  Mutation,
  Action,
} from 'vuex-module-decorators';

export enum PopupType {
  Victory = 'Victory',
  Calendar = 'Calendar',
  RevealPuzzle = 'RevealPuzzle',
  ClearPuzzle = 'ClearPuzzle',
  Print = 'Print',
  Pause = 'Pause',
  Help = 'Help',
  Hint = 'Hint',
  ChangeDate = 'ChangeDate',
}

@Module({ namespaced: true })
export default class UIData extends VuexModule {
  public popup: PopupType | null = null;

  public outOfFocus = false;

  @Mutation
  public openPopup(popup: PopupType): void {
    this.popup = popup;
  }

  @Mutation
  public closePopup(): void {
    playSound('buttonClickSound');
    this.popup = null;
  }

  @Action
  public openRevealPuzzlePopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.RevealPuzzle);
  }

  @Action
  public openClearPuzzlePopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.ClearPuzzle);
  }

  @Action
  public openPrintPopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.Print);
  }

  @Action
  public openVictoryPopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.Victory);
  }

  @Action
  public openCalendarPopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.Calendar);
  }

  @Action
  public openPausePopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.Pause);
  }

  @Action
  public openHelpPopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.Help);
  }

  @Action
  public openHintPopup(): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.Hint);
  }

  @Action
  public openChangeDatePopup(dayEntry: CalendarEntry): void {
    playSound('buttonClickSound');
    this.context.commit('openPopup', PopupType.ChangeDate);
  }
}
